import type { TOC } from '@ember/component/template-only';

import AgentsEntryPoint from '@databox/ember-integrations/lib/components/Agents/AgentsEntryPoint';

import { TrackingEvent } from 'webapp/enums/tracking';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import CommonComingSoonPageComponent from 'webapp/components/common/coming-soon-page';

const AgentsRouteTemplate: TOC<object> = <template>
	<CommonComingSoonPageComponent
		@settingKey={{UserSettingsKey.COMING_SOON_WAITLIST_AGENTS}}
		@eventName={{TrackingEvent.COMING_SOON_WAITLIST_AGENTS}}
		@entryPoint={{AgentsEntryPoint}}
	/>
</template>;

export default AgentsRouteTemplate;
